'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { CardSection } from 'foundations-components/transitional/components/Card';
import { ProfileListing } from 'marketplace-ui-solutions-core/records/ProfileListing';
import ProfileCardWrapper from './ProfileCardWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AboutCard = ({
  profileListing
}) => {
  const {
    name,
    description
  } = profileListing;
  return /*#__PURE__*/_jsx(ProfileCardWrapper, {
    id: "about",
    dataTestId: "profile-about-card",
    children: /*#__PURE__*/_jsxs(CardSection, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h3",
        marginBlockEnd: "600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.profile.about",
          options: {
            name
          }
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-200",
        whiteSpace: "pre-wrap",
        children: description
      })]
    })
  });
};
AboutCard.propTypes = {
  profileListing: PropTypes.instanceOf(ProfileListing)
};
export default AboutCard;